/**
 * #subreddit.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { BoolValue, Int32Value, StringValue } from "../../google/protobuf/wrappers.js";
import { messageTypeRegistry } from "../../typeRegistry.js";
import { CommentContributionSettings, UserFlairRichtext } from "./common.js";
function createBaseSubreddit() {
    return {
        acceptFollowers: undefined,
        accountsActiveIsFuzzed: undefined,
        accountsActive: undefined,
        activeUserCount: undefined,
        advertiserCategory: undefined,
        allOriginalContent: undefined,
        allowChatPostCreation: undefined,
        allowDiscovery: undefined,
        allowGalleries: undefined,
        allowImages: undefined,
        allowPolls: undefined,
        allowPredictionContributors: undefined,
        allowPredictionsTournament: undefined,
        allowPredictions: undefined,
        allowTalks: undefined,
        allowVideogifs: undefined,
        allowVideos: undefined,
        allowedMediaInComments: [],
        bannerBackgroundColor: undefined,
        bannerBackgroundImage: undefined,
        bannerImg: undefined,
        bannerSize: [],
        canAssignLinkFlair: undefined,
        canAssignUserFlair: undefined,
        coins: undefined,
        collapseDeletedComments: undefined,
        commentContributionSettings: undefined,
        commentScoreHideMins: undefined,
        communityIcon: undefined,
        communityReviewed: undefined,
        contentCategory: undefined,
        createdUtc: undefined,
        created: undefined,
        defaultSet: undefined,
        description: undefined,
        descriptionHtml: undefined,
        disableContributorRequests: undefined,
        displayName: undefined,
        displayNamePrefixed: undefined,
        emojisCustomSize: [],
        emojisEnabled: undefined,
        freeFormReports: undefined,
        hasMenuWidget: undefined,
        headerImg: undefined,
        headerSize: [],
        headerTitle: undefined,
        hideAds: undefined,
        iconColor: undefined,
        iconImg: undefined,
        iconSize: [],
        id: undefined,
        isChatPostFeatureEnabled: undefined,
        isCrosspostableSubreddit: undefined,
        isDefaultBanner: undefined,
        isDefaultIcon: undefined,
        isEnrolledInNewModmail: undefined,
        keyColor: undefined,
        lang: undefined,
        linkFlairEnabled: undefined,
        linkFlairPosition: undefined,
        mobileBannerImage: undefined,
        name: undefined,
        notificationLevel: undefined,
        originalContentTagEnabled: undefined,
        over18: undefined,
        predictionLeaderboardEntryType: undefined,
        previousNames: [],
        primaryColor: undefined,
        publicDescription: undefined,
        publicDescriptionHtml: undefined,
        publicTraffic: undefined,
        quarantine: undefined,
        restrictCommenting: undefined,
        restrictPosting: undefined,
        shouldArchivePosts: undefined,
        shouldShowMediaInCommentsSetting: undefined,
        showMedia: undefined,
        showMediaPreview: undefined,
        spoilersEnabled: undefined,
        submissionType: undefined,
        submitLinkLabel: undefined,
        submitText: undefined,
        submitTextHtml: undefined,
        submitTextLabel: undefined,
        subredditType: undefined,
        subscribers: undefined,
        suggestedCommentSort: undefined,
        title: undefined,
        url: undefined,
        userCanFlairInSr: undefined,
        userFlairBackgroundColor: undefined,
        userFlairCssClass: undefined,
        userFlairEnabledInSr: undefined,
        userFlairPosition: undefined,
        userFlairRichtext: [],
        userFlairTemplateId: undefined,
        userFlairText: undefined,
        userFlairTextColor: undefined,
        userFlairType: undefined,
        userHasFavorited: undefined,
        userIsBanned: undefined,
        userIsContributor: undefined,
        userIsModerator: undefined,
        userIsSubscriber: undefined,
        userSrFlairEnabled: undefined,
        userSrThemeEnabled: undefined,
        videostreamLinksCount: undefined,
        whitelistStatus: undefined,
        wikiEnabled: undefined,
        wls: undefined,
        markedSpam: undefined,
        postRequirements: undefined,
        userIsMuted: false,
    };
}
export const Subreddit = {
    $type: "devvit.reddit.Subreddit",
    encode(message, writer = _m0.Writer.create()) {
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(10).fork()).ldelim();
        }
        if (message.accountsActiveIsFuzzed !== undefined) {
            BoolValue.encode({ value: message.accountsActiveIsFuzzed }, writer.uint32(18).fork()).ldelim();
        }
        if (message.accountsActive !== undefined) {
            Int32Value.encode({ value: message.accountsActive }, writer.uint32(26).fork()).ldelim();
        }
        if (message.activeUserCount !== undefined) {
            Int32Value.encode({ value: message.activeUserCount }, writer.uint32(34).fork()).ldelim();
        }
        if (message.advertiserCategory !== undefined) {
            StringValue.encode({ value: message.advertiserCategory }, writer.uint32(42).fork()).ldelim();
        }
        if (message.allOriginalContent !== undefined) {
            BoolValue.encode({ value: message.allOriginalContent }, writer.uint32(50).fork()).ldelim();
        }
        if (message.allowChatPostCreation !== undefined) {
            BoolValue.encode({ value: message.allowChatPostCreation }, writer.uint32(58).fork()).ldelim();
        }
        if (message.allowDiscovery !== undefined) {
            BoolValue.encode({ value: message.allowDiscovery }, writer.uint32(66).fork()).ldelim();
        }
        if (message.allowGalleries !== undefined) {
            BoolValue.encode({ value: message.allowGalleries }, writer.uint32(74).fork()).ldelim();
        }
        if (message.allowImages !== undefined) {
            BoolValue.encode({ value: message.allowImages }, writer.uint32(82).fork()).ldelim();
        }
        if (message.allowPolls !== undefined) {
            BoolValue.encode({ value: message.allowPolls }, writer.uint32(90).fork()).ldelim();
        }
        if (message.allowPredictionContributors !== undefined) {
            BoolValue.encode({ value: message.allowPredictionContributors }, writer.uint32(98).fork()).ldelim();
        }
        if (message.allowPredictionsTournament !== undefined) {
            BoolValue.encode({ value: message.allowPredictionsTournament }, writer.uint32(106).fork()).ldelim();
        }
        if (message.allowPredictions !== undefined) {
            BoolValue.encode({ value: message.allowPredictions }, writer.uint32(114).fork()).ldelim();
        }
        if (message.allowTalks !== undefined) {
            BoolValue.encode({ value: message.allowTalks }, writer.uint32(122).fork()).ldelim();
        }
        if (message.allowVideogifs !== undefined) {
            BoolValue.encode({ value: message.allowVideogifs }, writer.uint32(130).fork()).ldelim();
        }
        if (message.allowVideos !== undefined) {
            BoolValue.encode({ value: message.allowVideos }, writer.uint32(138).fork()).ldelim();
        }
        for (const v of message.allowedMediaInComments) {
            StringValue.encode({ value: v }, writer.uint32(146).fork()).ldelim();
        }
        if (message.bannerBackgroundColor !== undefined) {
            StringValue.encode({ value: message.bannerBackgroundColor }, writer.uint32(154).fork()).ldelim();
        }
        if (message.bannerBackgroundImage !== undefined) {
            StringValue.encode({ value: message.bannerBackgroundImage }, writer.uint32(162).fork()).ldelim();
        }
        if (message.bannerImg !== undefined) {
            StringValue.encode({ value: message.bannerImg }, writer.uint32(170).fork()).ldelim();
        }
        for (const v of message.bannerSize) {
            Int32Value.encode({ value: v }, writer.uint32(178).fork()).ldelim();
        }
        if (message.canAssignLinkFlair !== undefined) {
            BoolValue.encode({ value: message.canAssignLinkFlair }, writer.uint32(186).fork()).ldelim();
        }
        if (message.canAssignUserFlair !== undefined) {
            BoolValue.encode({ value: message.canAssignUserFlair }, writer.uint32(194).fork()).ldelim();
        }
        if (message.coins !== undefined) {
            Int32Value.encode({ value: message.coins }, writer.uint32(202).fork()).ldelim();
        }
        if (message.collapseDeletedComments !== undefined) {
            BoolValue.encode({ value: message.collapseDeletedComments }, writer.uint32(210).fork()).ldelim();
        }
        if (message.commentContributionSettings !== undefined) {
            CommentContributionSettings.encode(message.commentContributionSettings, writer.uint32(218).fork()).ldelim();
        }
        if (message.commentScoreHideMins !== undefined) {
            Int32Value.encode({ value: message.commentScoreHideMins }, writer.uint32(226).fork()).ldelim();
        }
        if (message.communityIcon !== undefined) {
            StringValue.encode({ value: message.communityIcon }, writer.uint32(234).fork()).ldelim();
        }
        if (message.communityReviewed !== undefined) {
            BoolValue.encode({ value: message.communityReviewed }, writer.uint32(242).fork()).ldelim();
        }
        if (message.contentCategory !== undefined) {
            StringValue.encode({ value: message.contentCategory }, writer.uint32(250).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int32Value.encode({ value: message.createdUtc }, writer.uint32(258).fork()).ldelim();
        }
        if (message.created !== undefined) {
            Int32Value.encode({ value: message.created }, writer.uint32(266).fork()).ldelim();
        }
        if (message.defaultSet !== undefined) {
            BoolValue.encode({ value: message.defaultSet }, writer.uint32(274).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(282).fork()).ldelim();
        }
        if (message.descriptionHtml !== undefined) {
            StringValue.encode({ value: message.descriptionHtml }, writer.uint32(290).fork()).ldelim();
        }
        if (message.disableContributorRequests !== undefined) {
            BoolValue.encode({ value: message.disableContributorRequests }, writer.uint32(298).fork()).ldelim();
        }
        if (message.displayName !== undefined) {
            StringValue.encode({ value: message.displayName }, writer.uint32(306).fork()).ldelim();
        }
        if (message.displayNamePrefixed !== undefined) {
            StringValue.encode({ value: message.displayNamePrefixed }, writer.uint32(314).fork()).ldelim();
        }
        for (const v of message.emojisCustomSize) {
            Int32Value.encode({ value: v }, writer.uint32(322).fork()).ldelim();
        }
        if (message.emojisEnabled !== undefined) {
            BoolValue.encode({ value: message.emojisEnabled }, writer.uint32(330).fork()).ldelim();
        }
        if (message.freeFormReports !== undefined) {
            BoolValue.encode({ value: message.freeFormReports }, writer.uint32(338).fork()).ldelim();
        }
        if (message.hasMenuWidget !== undefined) {
            BoolValue.encode({ value: message.hasMenuWidget }, writer.uint32(346).fork()).ldelim();
        }
        if (message.headerImg !== undefined) {
            StringValue.encode({ value: message.headerImg }, writer.uint32(354).fork()).ldelim();
        }
        for (const v of message.headerSize) {
            Int32Value.encode({ value: v }, writer.uint32(362).fork()).ldelim();
        }
        if (message.headerTitle !== undefined) {
            StringValue.encode({ value: message.headerTitle }, writer.uint32(370).fork()).ldelim();
        }
        if (message.hideAds !== undefined) {
            BoolValue.encode({ value: message.hideAds }, writer.uint32(378).fork()).ldelim();
        }
        if (message.iconColor !== undefined) {
            StringValue.encode({ value: message.iconColor }, writer.uint32(386).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(394).fork()).ldelim();
        }
        for (const v of message.iconSize) {
            Int32Value.encode({ value: v }, writer.uint32(402).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(410).fork()).ldelim();
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            BoolValue.encode({ value: message.isChatPostFeatureEnabled }, writer.uint32(418).fork()).ldelim();
        }
        if (message.isCrosspostableSubreddit !== undefined) {
            BoolValue.encode({ value: message.isCrosspostableSubreddit }, writer.uint32(426).fork()).ldelim();
        }
        if (message.isDefaultBanner !== undefined) {
            BoolValue.encode({ value: message.isDefaultBanner }, writer.uint32(434).fork()).ldelim();
        }
        if (message.isDefaultIcon !== undefined) {
            BoolValue.encode({ value: message.isDefaultIcon }, writer.uint32(442).fork()).ldelim();
        }
        if (message.isEnrolledInNewModmail !== undefined) {
            BoolValue.encode({ value: message.isEnrolledInNewModmail }, writer.uint32(450).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(458).fork()).ldelim();
        }
        if (message.lang !== undefined) {
            StringValue.encode({ value: message.lang }, writer.uint32(466).fork()).ldelim();
        }
        if (message.linkFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.linkFlairEnabled }, writer.uint32(474).fork()).ldelim();
        }
        if (message.linkFlairPosition !== undefined) {
            StringValue.encode({ value: message.linkFlairPosition }, writer.uint32(482).fork()).ldelim();
        }
        if (message.mobileBannerImage !== undefined) {
            StringValue.encode({ value: message.mobileBannerImage }, writer.uint32(490).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(498).fork()).ldelim();
        }
        if (message.notificationLevel !== undefined) {
            StringValue.encode({ value: message.notificationLevel }, writer.uint32(506).fork()).ldelim();
        }
        if (message.originalContentTagEnabled !== undefined) {
            StringValue.encode({ value: message.originalContentTagEnabled }, writer.uint32(514).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(522).fork()).ldelim();
        }
        if (message.predictionLeaderboardEntryType !== undefined) {
            StringValue.encode({ value: message.predictionLeaderboardEntryType }, writer.uint32(530).fork()).ldelim();
        }
        for (const v of message.previousNames) {
            StringValue.encode({ value: v }, writer.uint32(538).fork()).ldelim();
        }
        if (message.primaryColor !== undefined) {
            StringValue.encode({ value: message.primaryColor }, writer.uint32(546).fork()).ldelim();
        }
        if (message.publicDescription !== undefined) {
            StringValue.encode({ value: message.publicDescription }, writer.uint32(554).fork()).ldelim();
        }
        if (message.publicDescriptionHtml !== undefined) {
            StringValue.encode({ value: message.publicDescriptionHtml }, writer.uint32(562).fork()).ldelim();
        }
        if (message.publicTraffic !== undefined) {
            BoolValue.encode({ value: message.publicTraffic }, writer.uint32(570).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(578).fork()).ldelim();
        }
        if (message.restrictCommenting !== undefined) {
            BoolValue.encode({ value: message.restrictCommenting }, writer.uint32(586).fork()).ldelim();
        }
        if (message.restrictPosting !== undefined) {
            BoolValue.encode({ value: message.restrictPosting }, writer.uint32(594).fork()).ldelim();
        }
        if (message.shouldArchivePosts !== undefined) {
            BoolValue.encode({ value: message.shouldArchivePosts }, writer.uint32(602).fork()).ldelim();
        }
        if (message.shouldShowMediaInCommentsSetting !== undefined) {
            BoolValue.encode({ value: message.shouldShowMediaInCommentsSetting }, writer.uint32(610).fork()).ldelim();
        }
        if (message.showMedia !== undefined) {
            BoolValue.encode({ value: message.showMedia }, writer.uint32(618).fork()).ldelim();
        }
        if (message.showMediaPreview !== undefined) {
            BoolValue.encode({ value: message.showMediaPreview }, writer.uint32(626).fork()).ldelim();
        }
        if (message.spoilersEnabled !== undefined) {
            BoolValue.encode({ value: message.spoilersEnabled }, writer.uint32(634).fork()).ldelim();
        }
        if (message.submissionType !== undefined) {
            StringValue.encode({ value: message.submissionType }, writer.uint32(642).fork()).ldelim();
        }
        if (message.submitLinkLabel !== undefined) {
            StringValue.encode({ value: message.submitLinkLabel }, writer.uint32(650).fork()).ldelim();
        }
        if (message.submitText !== undefined) {
            StringValue.encode({ value: message.submitText }, writer.uint32(658).fork()).ldelim();
        }
        if (message.submitTextHtml !== undefined) {
            StringValue.encode({ value: message.submitTextHtml }, writer.uint32(666).fork()).ldelim();
        }
        if (message.submitTextLabel !== undefined) {
            StringValue.encode({ value: message.submitTextLabel }, writer.uint32(674).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(682).fork()).ldelim();
        }
        if (message.subscribers !== undefined) {
            Int32Value.encode({ value: message.subscribers }, writer.uint32(690).fork()).ldelim();
        }
        if (message.suggestedCommentSort !== undefined) {
            StringValue.encode({ value: message.suggestedCommentSort }, writer.uint32(698).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(706).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(714).fork()).ldelim();
        }
        if (message.userCanFlairInSr !== undefined) {
            BoolValue.encode({ value: message.userCanFlairInSr }, writer.uint32(722).fork()).ldelim();
        }
        if (message.userFlairBackgroundColor !== undefined) {
            StringValue.encode({ value: message.userFlairBackgroundColor }, writer.uint32(730).fork()).ldelim();
        }
        if (message.userFlairCssClass !== undefined) {
            StringValue.encode({ value: message.userFlairCssClass }, writer.uint32(738).fork()).ldelim();
        }
        if (message.userFlairEnabledInSr !== undefined) {
            BoolValue.encode({ value: message.userFlairEnabledInSr }, writer.uint32(746).fork()).ldelim();
        }
        if (message.userFlairPosition !== undefined) {
            StringValue.encode({ value: message.userFlairPosition }, writer.uint32(754).fork()).ldelim();
        }
        for (const v of message.userFlairRichtext) {
            UserFlairRichtext.encode(v, writer.uint32(762).fork()).ldelim();
        }
        if (message.userFlairTemplateId !== undefined) {
            StringValue.encode({ value: message.userFlairTemplateId }, writer.uint32(770).fork()).ldelim();
        }
        if (message.userFlairText !== undefined) {
            StringValue.encode({ value: message.userFlairText }, writer.uint32(778).fork()).ldelim();
        }
        if (message.userFlairTextColor !== undefined) {
            StringValue.encode({ value: message.userFlairTextColor }, writer.uint32(786).fork()).ldelim();
        }
        if (message.userFlairType !== undefined) {
            StringValue.encode({ value: message.userFlairType }, writer.uint32(794).fork()).ldelim();
        }
        if (message.userHasFavorited !== undefined) {
            BoolValue.encode({ value: message.userHasFavorited }, writer.uint32(802).fork()).ldelim();
        }
        if (message.userIsBanned !== undefined) {
            BoolValue.encode({ value: message.userIsBanned }, writer.uint32(810).fork()).ldelim();
        }
        if (message.userIsContributor !== undefined) {
            BoolValue.encode({ value: message.userIsContributor }, writer.uint32(818).fork()).ldelim();
        }
        if (message.userIsModerator !== undefined) {
            BoolValue.encode({ value: message.userIsModerator }, writer.uint32(826).fork()).ldelim();
        }
        if (message.userIsSubscriber !== undefined) {
            BoolValue.encode({ value: message.userIsSubscriber }, writer.uint32(842).fork()).ldelim();
        }
        if (message.userSrFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.userSrFlairEnabled }, writer.uint32(850).fork()).ldelim();
        }
        if (message.userSrThemeEnabled !== undefined) {
            BoolValue.encode({ value: message.userSrThemeEnabled }, writer.uint32(858).fork()).ldelim();
        }
        if (message.videostreamLinksCount !== undefined) {
            Int32Value.encode({ value: message.videostreamLinksCount }, writer.uint32(866).fork()).ldelim();
        }
        if (message.whitelistStatus !== undefined) {
            StringValue.encode({ value: message.whitelistStatus }, writer.uint32(874).fork()).ldelim();
        }
        if (message.wikiEnabled !== undefined) {
            BoolValue.encode({ value: message.wikiEnabled }, writer.uint32(882).fork()).ldelim();
        }
        if (message.wls !== undefined) {
            Int32Value.encode({ value: message.wls }, writer.uint32(890).fork()).ldelim();
        }
        if (message.markedSpam !== undefined) {
            BoolValue.encode({ value: message.markedSpam }, writer.uint32(898).fork()).ldelim();
        }
        if (message.postRequirements !== undefined) {
            Subreddit_PostRequirements.encode(message.postRequirements, writer.uint32(906).fork()).ldelim();
        }
        if (message.userIsMuted !== false) {
            writer.uint32(912).bool(message.userIsMuted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubreddit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.accountsActiveIsFuzzed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.accountsActive = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.activeUserCount = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.advertiserCategory = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.allOriginalContent = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.allowChatPostCreation = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.allowDiscovery = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.allowGalleries = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.allowImages = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.allowPolls = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.allowPredictionContributors = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.allowPredictionsTournament = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.allowPredictions = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.allowTalks = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.allowVideogifs = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.allowVideos = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.allowedMediaInComments.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.bannerBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.bannerBackgroundImage = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.bannerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.bannerSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.canAssignLinkFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.canAssignUserFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.coins = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.collapseDeletedComments = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.commentContributionSettings = CommentContributionSettings.decode(reader, reader.uint32());
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.commentScoreHideMins = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.communityIcon = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.communityReviewed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.contentCategory = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.createdUtc = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.created = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.defaultSet = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.descriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.disableContributorRequests = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.displayName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.displayNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.emojisCustomSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.emojisEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.freeFormReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.hasMenuWidget = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.headerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.headerSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.headerTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.hideAds = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.iconColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.iconSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.isChatPostFeatureEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.isCrosspostableSubreddit = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.isDefaultBanner = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.isDefaultIcon = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.isEnrolledInNewModmail = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.lang = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.linkFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.linkFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.mobileBannerImage = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 62:
                    if (tag !== 498) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 63:
                    if (tag !== 506) {
                        break;
                    }
                    message.notificationLevel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 64:
                    if (tag !== 514) {
                        break;
                    }
                    message.originalContentTagEnabled = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 66:
                    if (tag !== 530) {
                        break;
                    }
                    message.predictionLeaderboardEntryType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 67:
                    if (tag !== 538) {
                        break;
                    }
                    message.previousNames.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 68:
                    if (tag !== 546) {
                        break;
                    }
                    message.primaryColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 69:
                    if (tag !== 554) {
                        break;
                    }
                    message.publicDescription = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 70:
                    if (tag !== 562) {
                        break;
                    }
                    message.publicDescriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 71:
                    if (tag !== 570) {
                        break;
                    }
                    message.publicTraffic = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 72:
                    if (tag !== 578) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 73:
                    if (tag !== 586) {
                        break;
                    }
                    message.restrictCommenting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 74:
                    if (tag !== 594) {
                        break;
                    }
                    message.restrictPosting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 75:
                    if (tag !== 602) {
                        break;
                    }
                    message.shouldArchivePosts = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 76:
                    if (tag !== 610) {
                        break;
                    }
                    message.shouldShowMediaInCommentsSetting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 77:
                    if (tag !== 618) {
                        break;
                    }
                    message.showMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 78:
                    if (tag !== 626) {
                        break;
                    }
                    message.showMediaPreview = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 79:
                    if (tag !== 634) {
                        break;
                    }
                    message.spoilersEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 80:
                    if (tag !== 642) {
                        break;
                    }
                    message.submissionType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 81:
                    if (tag !== 650) {
                        break;
                    }
                    message.submitLinkLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 82:
                    if (tag !== 658) {
                        break;
                    }
                    message.submitText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 83:
                    if (tag !== 666) {
                        break;
                    }
                    message.submitTextHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 84:
                    if (tag !== 674) {
                        break;
                    }
                    message.submitTextLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 85:
                    if (tag !== 682) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 86:
                    if (tag !== 690) {
                        break;
                    }
                    message.subscribers = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 87:
                    if (tag !== 698) {
                        break;
                    }
                    message.suggestedCommentSort = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 88:
                    if (tag !== 706) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 89:
                    if (tag !== 714) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 90:
                    if (tag !== 722) {
                        break;
                    }
                    message.userCanFlairInSr = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 91:
                    if (tag !== 730) {
                        break;
                    }
                    message.userFlairBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 92:
                    if (tag !== 738) {
                        break;
                    }
                    message.userFlairCssClass = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 93:
                    if (tag !== 746) {
                        break;
                    }
                    message.userFlairEnabledInSr = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 94:
                    if (tag !== 754) {
                        break;
                    }
                    message.userFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 95:
                    if (tag !== 762) {
                        break;
                    }
                    message.userFlairRichtext.push(UserFlairRichtext.decode(reader, reader.uint32()));
                    continue;
                case 96:
                    if (tag !== 770) {
                        break;
                    }
                    message.userFlairTemplateId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 97:
                    if (tag !== 778) {
                        break;
                    }
                    message.userFlairText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 98:
                    if (tag !== 786) {
                        break;
                    }
                    message.userFlairTextColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 99:
                    if (tag !== 794) {
                        break;
                    }
                    message.userFlairType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.userHasFavorited = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.userIsBanned = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.userIsContributor = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.userIsModerator = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.userIsSubscriber = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 106:
                    if (tag !== 850) {
                        break;
                    }
                    message.userSrFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.userSrThemeEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.videostreamLinksCount = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 109:
                    if (tag !== 874) {
                        break;
                    }
                    message.whitelistStatus = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.wikiEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.wls = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.markedSpam = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.postRequirements = Subreddit_PostRequirements.decode(reader, reader.uint32());
                    continue;
                case 114:
                    if (tag !== 912) {
                        break;
                    }
                    message.userIsMuted = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            accountsActiveIsFuzzed: isSet(object.accountsActiveIsFuzzed) ? Boolean(object.accountsActiveIsFuzzed) : undefined,
            accountsActive: isSet(object.accountsActive) ? Number(object.accountsActive) : undefined,
            activeUserCount: isSet(object.activeUserCount) ? Number(object.activeUserCount) : undefined,
            advertiserCategory: isSet(object.advertiserCategory) ? String(object.advertiserCategory) : undefined,
            allOriginalContent: isSet(object.allOriginalContent) ? Boolean(object.allOriginalContent) : undefined,
            allowChatPostCreation: isSet(object.allowChatPostCreation) ? Boolean(object.allowChatPostCreation) : undefined,
            allowDiscovery: isSet(object.allowDiscovery) ? Boolean(object.allowDiscovery) : undefined,
            allowGalleries: isSet(object.allowGalleries) ? Boolean(object.allowGalleries) : undefined,
            allowImages: isSet(object.allowImages) ? Boolean(object.allowImages) : undefined,
            allowPolls: isSet(object.allowPolls) ? Boolean(object.allowPolls) : undefined,
            allowPredictionContributors: isSet(object.allowPredictionContributors)
                ? Boolean(object.allowPredictionContributors)
                : undefined,
            allowPredictionsTournament: isSet(object.allowPredictionsTournament)
                ? Boolean(object.allowPredictionsTournament)
                : undefined,
            allowPredictions: isSet(object.allowPredictions) ? Boolean(object.allowPredictions) : undefined,
            allowTalks: isSet(object.allowTalks) ? Boolean(object.allowTalks) : undefined,
            allowVideogifs: isSet(object.allowVideogifs) ? Boolean(object.allowVideogifs) : undefined,
            allowVideos: isSet(object.allowVideos) ? Boolean(object.allowVideos) : undefined,
            allowedMediaInComments: globalThis.Array.isArray(object?.allowedMediaInComments)
                ? object.allowedMediaInComments.map((e) => String(e))
                : [],
            bannerBackgroundColor: isSet(object.bannerBackgroundColor) ? String(object.bannerBackgroundColor) : undefined,
            bannerBackgroundImage: isSet(object.bannerBackgroundImage) ? String(object.bannerBackgroundImage) : undefined,
            bannerImg: isSet(object.bannerImg) ? String(object.bannerImg) : undefined,
            bannerSize: globalThis.Array.isArray(object?.bannerSize) ? object.bannerSize.map((e) => Number(e)) : [],
            canAssignLinkFlair: isSet(object.canAssignLinkFlair) ? Boolean(object.canAssignLinkFlair) : undefined,
            canAssignUserFlair: isSet(object.canAssignUserFlair) ? Boolean(object.canAssignUserFlair) : undefined,
            coins: isSet(object.coins) ? Number(object.coins) : undefined,
            collapseDeletedComments: isSet(object.collapseDeletedComments)
                ? Boolean(object.collapseDeletedComments)
                : undefined,
            commentContributionSettings: isSet(object.commentContributionSettings)
                ? CommentContributionSettings.fromJSON(object.commentContributionSettings)
                : undefined,
            commentScoreHideMins: isSet(object.commentScoreHideMins) ? Number(object.commentScoreHideMins) : undefined,
            communityIcon: isSet(object.communityIcon) ? String(object.communityIcon) : undefined,
            communityReviewed: isSet(object.communityReviewed) ? Boolean(object.communityReviewed) : undefined,
            contentCategory: isSet(object.contentCategory) ? String(object.contentCategory) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            created: isSet(object.created) ? Number(object.created) : undefined,
            defaultSet: isSet(object.defaultSet) ? Boolean(object.defaultSet) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            descriptionHtml: isSet(object.descriptionHtml) ? String(object.descriptionHtml) : undefined,
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? Boolean(object.disableContributorRequests)
                : undefined,
            displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
            displayNamePrefixed: isSet(object.displayNamePrefixed) ? String(object.displayNamePrefixed) : undefined,
            emojisCustomSize: globalThis.Array.isArray(object?.emojisCustomSize)
                ? object.emojisCustomSize.map((e) => Number(e))
                : [],
            emojisEnabled: isSet(object.emojisEnabled) ? Boolean(object.emojisEnabled) : undefined,
            freeFormReports: isSet(object.freeFormReports) ? Boolean(object.freeFormReports) : undefined,
            hasMenuWidget: isSet(object.hasMenuWidget) ? Boolean(object.hasMenuWidget) : undefined,
            headerImg: isSet(object.headerImg) ? String(object.headerImg) : undefined,
            headerSize: globalThis.Array.isArray(object?.headerSize) ? object.headerSize.map((e) => Number(e)) : [],
            headerTitle: isSet(object.headerTitle) ? String(object.headerTitle) : undefined,
            hideAds: isSet(object.hideAds) ? Boolean(object.hideAds) : undefined,
            iconColor: isSet(object.iconColor) ? String(object.iconColor) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            iconSize: globalThis.Array.isArray(object?.iconSize) ? object.iconSize.map((e) => Number(e)) : [],
            id: isSet(object.id) ? String(object.id) : undefined,
            isChatPostFeatureEnabled: isSet(object.isChatPostFeatureEnabled)
                ? Boolean(object.isChatPostFeatureEnabled)
                : undefined,
            isCrosspostableSubreddit: isSet(object.isCrosspostableSubreddit)
                ? Boolean(object.isCrosspostableSubreddit)
                : undefined,
            isDefaultBanner: isSet(object.isDefaultBanner) ? Boolean(object.isDefaultBanner) : undefined,
            isDefaultIcon: isSet(object.isDefaultIcon) ? Boolean(object.isDefaultIcon) : undefined,
            isEnrolledInNewModmail: isSet(object.isEnrolledInNewModmail) ? Boolean(object.isEnrolledInNewModmail) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            lang: isSet(object.lang) ? String(object.lang) : undefined,
            linkFlairEnabled: isSet(object.linkFlairEnabled) ? Boolean(object.linkFlairEnabled) : undefined,
            linkFlairPosition: isSet(object.linkFlairPosition) ? String(object.linkFlairPosition) : undefined,
            mobileBannerImage: isSet(object.mobileBannerImage) ? String(object.mobileBannerImage) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            notificationLevel: isSet(object.notificationLevel) ? String(object.notificationLevel) : undefined,
            originalContentTagEnabled: isSet(object.originalContentTagEnabled)
                ? String(object.originalContentTagEnabled)
                : undefined,
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            predictionLeaderboardEntryType: isSet(object.predictionLeaderboardEntryType)
                ? String(object.predictionLeaderboardEntryType)
                : undefined,
            previousNames: globalThis.Array.isArray(object?.previousNames)
                ? object.previousNames.map((e) => String(e))
                : [],
            primaryColor: isSet(object.primaryColor) ? String(object.primaryColor) : undefined,
            publicDescription: isSet(object.publicDescription) ? String(object.publicDescription) : undefined,
            publicDescriptionHtml: isSet(object.publicDescriptionHtml) ? String(object.publicDescriptionHtml) : undefined,
            publicTraffic: isSet(object.publicTraffic) ? Boolean(object.publicTraffic) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            restrictCommenting: isSet(object.restrictCommenting) ? Boolean(object.restrictCommenting) : undefined,
            restrictPosting: isSet(object.restrictPosting) ? Boolean(object.restrictPosting) : undefined,
            shouldArchivePosts: isSet(object.shouldArchivePosts) ? Boolean(object.shouldArchivePosts) : undefined,
            shouldShowMediaInCommentsSetting: isSet(object.shouldShowMediaInCommentsSetting)
                ? Boolean(object.shouldShowMediaInCommentsSetting)
                : undefined,
            showMedia: isSet(object.showMedia) ? Boolean(object.showMedia) : undefined,
            showMediaPreview: isSet(object.showMediaPreview) ? Boolean(object.showMediaPreview) : undefined,
            spoilersEnabled: isSet(object.spoilersEnabled) ? Boolean(object.spoilersEnabled) : undefined,
            submissionType: isSet(object.submissionType) ? String(object.submissionType) : undefined,
            submitLinkLabel: isSet(object.submitLinkLabel) ? String(object.submitLinkLabel) : undefined,
            submitText: isSet(object.submitText) ? String(object.submitText) : undefined,
            submitTextHtml: isSet(object.submitTextHtml) ? String(object.submitTextHtml) : undefined,
            submitTextLabel: isSet(object.submitTextLabel) ? String(object.submitTextLabel) : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            subscribers: isSet(object.subscribers) ? Number(object.subscribers) : undefined,
            suggestedCommentSort: isSet(object.suggestedCommentSort) ? String(object.suggestedCommentSort) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            userCanFlairInSr: isSet(object.userCanFlairInSr) ? Boolean(object.userCanFlairInSr) : undefined,
            userFlairBackgroundColor: isSet(object.userFlairBackgroundColor)
                ? String(object.userFlairBackgroundColor)
                : undefined,
            userFlairCssClass: isSet(object.userFlairCssClass) ? String(object.userFlairCssClass) : undefined,
            userFlairEnabledInSr: isSet(object.userFlairEnabledInSr) ? Boolean(object.userFlairEnabledInSr) : undefined,
            userFlairPosition: isSet(object.userFlairPosition) ? String(object.userFlairPosition) : undefined,
            userFlairRichtext: globalThis.Array.isArray(object?.userFlairRichtext)
                ? object.userFlairRichtext.map((e) => UserFlairRichtext.fromJSON(e))
                : [],
            userFlairTemplateId: isSet(object.userFlairTemplateId) ? String(object.userFlairTemplateId) : undefined,
            userFlairText: isSet(object.userFlairText) ? String(object.userFlairText) : undefined,
            userFlairTextColor: isSet(object.userFlairTextColor) ? String(object.userFlairTextColor) : undefined,
            userFlairType: isSet(object.userFlairType) ? String(object.userFlairType) : undefined,
            userHasFavorited: isSet(object.userHasFavorited) ? Boolean(object.userHasFavorited) : undefined,
            userIsBanned: isSet(object.userIsBanned) ? Boolean(object.userIsBanned) : undefined,
            userIsContributor: isSet(object.userIsContributor) ? Boolean(object.userIsContributor) : undefined,
            userIsModerator: isSet(object.userIsModerator) ? Boolean(object.userIsModerator) : undefined,
            userIsSubscriber: isSet(object.userIsSubscriber) ? Boolean(object.userIsSubscriber) : undefined,
            userSrFlairEnabled: isSet(object.userSrFlairEnabled) ? Boolean(object.userSrFlairEnabled) : undefined,
            userSrThemeEnabled: isSet(object.userSrThemeEnabled) ? Boolean(object.userSrThemeEnabled) : undefined,
            videostreamLinksCount: isSet(object.videostreamLinksCount) ? Number(object.videostreamLinksCount) : undefined,
            whitelistStatus: isSet(object.whitelistStatus) ? String(object.whitelistStatus) : undefined,
            wikiEnabled: isSet(object.wikiEnabled) ? Boolean(object.wikiEnabled) : undefined,
            wls: isSet(object.wls) ? Number(object.wls) : undefined,
            markedSpam: isSet(object.markedSpam) ? Boolean(object.markedSpam) : undefined,
            postRequirements: isSet(object.postRequirements)
                ? Subreddit_PostRequirements.fromJSON(object.postRequirements)
                : undefined,
            userIsMuted: isSet(object.userIsMuted) ? globalThis.Boolean(object.userIsMuted) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.accountsActiveIsFuzzed !== undefined) {
            obj.accountsActiveIsFuzzed = message.accountsActiveIsFuzzed;
        }
        if (message.accountsActive !== undefined) {
            obj.accountsActive = message.accountsActive;
        }
        if (message.activeUserCount !== undefined) {
            obj.activeUserCount = message.activeUserCount;
        }
        if (message.advertiserCategory !== undefined) {
            obj.advertiserCategory = message.advertiserCategory;
        }
        if (message.allOriginalContent !== undefined) {
            obj.allOriginalContent = message.allOriginalContent;
        }
        if (message.allowChatPostCreation !== undefined) {
            obj.allowChatPostCreation = message.allowChatPostCreation;
        }
        if (message.allowDiscovery !== undefined) {
            obj.allowDiscovery = message.allowDiscovery;
        }
        if (message.allowGalleries !== undefined) {
            obj.allowGalleries = message.allowGalleries;
        }
        if (message.allowImages !== undefined) {
            obj.allowImages = message.allowImages;
        }
        if (message.allowPolls !== undefined) {
            obj.allowPolls = message.allowPolls;
        }
        if (message.allowPredictionContributors !== undefined) {
            obj.allowPredictionContributors = message.allowPredictionContributors;
        }
        if (message.allowPredictionsTournament !== undefined) {
            obj.allowPredictionsTournament = message.allowPredictionsTournament;
        }
        if (message.allowPredictions !== undefined) {
            obj.allowPredictions = message.allowPredictions;
        }
        if (message.allowTalks !== undefined) {
            obj.allowTalks = message.allowTalks;
        }
        if (message.allowVideogifs !== undefined) {
            obj.allowVideogifs = message.allowVideogifs;
        }
        if (message.allowVideos !== undefined) {
            obj.allowVideos = message.allowVideos;
        }
        if (message.allowedMediaInComments?.length) {
            obj.allowedMediaInComments = message.allowedMediaInComments;
        }
        if (message.bannerBackgroundColor !== undefined) {
            obj.bannerBackgroundColor = message.bannerBackgroundColor;
        }
        if (message.bannerBackgroundImage !== undefined) {
            obj.bannerBackgroundImage = message.bannerBackgroundImage;
        }
        if (message.bannerImg !== undefined) {
            obj.bannerImg = message.bannerImg;
        }
        if (message.bannerSize?.length) {
            obj.bannerSize = message.bannerSize;
        }
        if (message.canAssignLinkFlair !== undefined) {
            obj.canAssignLinkFlair = message.canAssignLinkFlair;
        }
        if (message.canAssignUserFlair !== undefined) {
            obj.canAssignUserFlair = message.canAssignUserFlair;
        }
        if (message.coins !== undefined) {
            obj.coins = message.coins;
        }
        if (message.collapseDeletedComments !== undefined) {
            obj.collapseDeletedComments = message.collapseDeletedComments;
        }
        if (message.commentContributionSettings !== undefined) {
            obj.commentContributionSettings = CommentContributionSettings.toJSON(message.commentContributionSettings);
        }
        if (message.commentScoreHideMins !== undefined) {
            obj.commentScoreHideMins = message.commentScoreHideMins;
        }
        if (message.communityIcon !== undefined) {
            obj.communityIcon = message.communityIcon;
        }
        if (message.communityReviewed !== undefined) {
            obj.communityReviewed = message.communityReviewed;
        }
        if (message.contentCategory !== undefined) {
            obj.contentCategory = message.contentCategory;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.created !== undefined) {
            obj.created = message.created;
        }
        if (message.defaultSet !== undefined) {
            obj.defaultSet = message.defaultSet;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.descriptionHtml !== undefined) {
            obj.descriptionHtml = message.descriptionHtml;
        }
        if (message.disableContributorRequests !== undefined) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.displayName !== undefined) {
            obj.displayName = message.displayName;
        }
        if (message.displayNamePrefixed !== undefined) {
            obj.displayNamePrefixed = message.displayNamePrefixed;
        }
        if (message.emojisCustomSize?.length) {
            obj.emojisCustomSize = message.emojisCustomSize;
        }
        if (message.emojisEnabled !== undefined) {
            obj.emojisEnabled = message.emojisEnabled;
        }
        if (message.freeFormReports !== undefined) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.hasMenuWidget !== undefined) {
            obj.hasMenuWidget = message.hasMenuWidget;
        }
        if (message.headerImg !== undefined) {
            obj.headerImg = message.headerImg;
        }
        if (message.headerSize?.length) {
            obj.headerSize = message.headerSize;
        }
        if (message.headerTitle !== undefined) {
            obj.headerTitle = message.headerTitle;
        }
        if (message.hideAds !== undefined) {
            obj.hideAds = message.hideAds;
        }
        if (message.iconColor !== undefined) {
            obj.iconColor = message.iconColor;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.iconSize?.length) {
            obj.iconSize = message.iconSize;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.isChatPostFeatureEnabled !== undefined) {
            obj.isChatPostFeatureEnabled = message.isChatPostFeatureEnabled;
        }
        if (message.isCrosspostableSubreddit !== undefined) {
            obj.isCrosspostableSubreddit = message.isCrosspostableSubreddit;
        }
        if (message.isDefaultBanner !== undefined) {
            obj.isDefaultBanner = message.isDefaultBanner;
        }
        if (message.isDefaultIcon !== undefined) {
            obj.isDefaultIcon = message.isDefaultIcon;
        }
        if (message.isEnrolledInNewModmail !== undefined) {
            obj.isEnrolledInNewModmail = message.isEnrolledInNewModmail;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.lang !== undefined) {
            obj.lang = message.lang;
        }
        if (message.linkFlairEnabled !== undefined) {
            obj.linkFlairEnabled = message.linkFlairEnabled;
        }
        if (message.linkFlairPosition !== undefined) {
            obj.linkFlairPosition = message.linkFlairPosition;
        }
        if (message.mobileBannerImage !== undefined) {
            obj.mobileBannerImage = message.mobileBannerImage;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.notificationLevel !== undefined) {
            obj.notificationLevel = message.notificationLevel;
        }
        if (message.originalContentTagEnabled !== undefined) {
            obj.originalContentTagEnabled = message.originalContentTagEnabled;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.predictionLeaderboardEntryType !== undefined) {
            obj.predictionLeaderboardEntryType = message.predictionLeaderboardEntryType;
        }
        if (message.previousNames?.length) {
            obj.previousNames = message.previousNames;
        }
        if (message.primaryColor !== undefined) {
            obj.primaryColor = message.primaryColor;
        }
        if (message.publicDescription !== undefined) {
            obj.publicDescription = message.publicDescription;
        }
        if (message.publicDescriptionHtml !== undefined) {
            obj.publicDescriptionHtml = message.publicDescriptionHtml;
        }
        if (message.publicTraffic !== undefined) {
            obj.publicTraffic = message.publicTraffic;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.restrictCommenting !== undefined) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.restrictPosting !== undefined) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.shouldArchivePosts !== undefined) {
            obj.shouldArchivePosts = message.shouldArchivePosts;
        }
        if (message.shouldShowMediaInCommentsSetting !== undefined) {
            obj.shouldShowMediaInCommentsSetting = message.shouldShowMediaInCommentsSetting;
        }
        if (message.showMedia !== undefined) {
            obj.showMedia = message.showMedia;
        }
        if (message.showMediaPreview !== undefined) {
            obj.showMediaPreview = message.showMediaPreview;
        }
        if (message.spoilersEnabled !== undefined) {
            obj.spoilersEnabled = message.spoilersEnabled;
        }
        if (message.submissionType !== undefined) {
            obj.submissionType = message.submissionType;
        }
        if (message.submitLinkLabel !== undefined) {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.submitText !== undefined) {
            obj.submitText = message.submitText;
        }
        if (message.submitTextHtml !== undefined) {
            obj.submitTextHtml = message.submitTextHtml;
        }
        if (message.submitTextLabel !== undefined) {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.subscribers !== undefined) {
            obj.subscribers = message.subscribers;
        }
        if (message.suggestedCommentSort !== undefined) {
            obj.suggestedCommentSort = message.suggestedCommentSort;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.userCanFlairInSr !== undefined) {
            obj.userCanFlairInSr = message.userCanFlairInSr;
        }
        if (message.userFlairBackgroundColor !== undefined) {
            obj.userFlairBackgroundColor = message.userFlairBackgroundColor;
        }
        if (message.userFlairCssClass !== undefined) {
            obj.userFlairCssClass = message.userFlairCssClass;
        }
        if (message.userFlairEnabledInSr !== undefined) {
            obj.userFlairEnabledInSr = message.userFlairEnabledInSr;
        }
        if (message.userFlairPosition !== undefined) {
            obj.userFlairPosition = message.userFlairPosition;
        }
        if (message.userFlairRichtext?.length) {
            obj.userFlairRichtext = message.userFlairRichtext.map((e) => UserFlairRichtext.toJSON(e));
        }
        if (message.userFlairTemplateId !== undefined) {
            obj.userFlairTemplateId = message.userFlairTemplateId;
        }
        if (message.userFlairText !== undefined) {
            obj.userFlairText = message.userFlairText;
        }
        if (message.userFlairTextColor !== undefined) {
            obj.userFlairTextColor = message.userFlairTextColor;
        }
        if (message.userFlairType !== undefined) {
            obj.userFlairType = message.userFlairType;
        }
        if (message.userHasFavorited !== undefined) {
            obj.userHasFavorited = message.userHasFavorited;
        }
        if (message.userIsBanned !== undefined) {
            obj.userIsBanned = message.userIsBanned;
        }
        if (message.userIsContributor !== undefined) {
            obj.userIsContributor = message.userIsContributor;
        }
        if (message.userIsModerator !== undefined) {
            obj.userIsModerator = message.userIsModerator;
        }
        if (message.userIsSubscriber !== undefined) {
            obj.userIsSubscriber = message.userIsSubscriber;
        }
        if (message.userSrFlairEnabled !== undefined) {
            obj.userSrFlairEnabled = message.userSrFlairEnabled;
        }
        if (message.userSrThemeEnabled !== undefined) {
            obj.userSrThemeEnabled = message.userSrThemeEnabled;
        }
        if (message.videostreamLinksCount !== undefined) {
            obj.videostreamLinksCount = message.videostreamLinksCount;
        }
        if (message.whitelistStatus !== undefined) {
            obj.whitelistStatus = message.whitelistStatus;
        }
        if (message.wikiEnabled !== undefined) {
            obj.wikiEnabled = message.wikiEnabled;
        }
        if (message.wls !== undefined) {
            obj.wls = message.wls;
        }
        if (message.markedSpam !== undefined) {
            obj.markedSpam = message.markedSpam;
        }
        if (message.postRequirements !== undefined) {
            obj.postRequirements = Subreddit_PostRequirements.toJSON(message.postRequirements);
        }
        if (message.userIsMuted !== false) {
            obj.userIsMuted = message.userIsMuted;
        }
        return obj;
    },
    create(base) {
        return Subreddit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubreddit();
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.accountsActiveIsFuzzed = object.accountsActiveIsFuzzed ?? undefined;
        message.accountsActive = object.accountsActive ?? undefined;
        message.activeUserCount = object.activeUserCount ?? undefined;
        message.advertiserCategory = object.advertiserCategory ?? undefined;
        message.allOriginalContent = object.allOriginalContent ?? undefined;
        message.allowChatPostCreation = object.allowChatPostCreation ?? undefined;
        message.allowDiscovery = object.allowDiscovery ?? undefined;
        message.allowGalleries = object.allowGalleries ?? undefined;
        message.allowImages = object.allowImages ?? undefined;
        message.allowPolls = object.allowPolls ?? undefined;
        message.allowPredictionContributors = object.allowPredictionContributors ?? undefined;
        message.allowPredictionsTournament = object.allowPredictionsTournament ?? undefined;
        message.allowPredictions = object.allowPredictions ?? undefined;
        message.allowTalks = object.allowTalks ?? undefined;
        message.allowVideogifs = object.allowVideogifs ?? undefined;
        message.allowVideos = object.allowVideos ?? undefined;
        message.allowedMediaInComments = object.allowedMediaInComments?.map((e) => e) || [];
        message.bannerBackgroundColor = object.bannerBackgroundColor ?? undefined;
        message.bannerBackgroundImage = object.bannerBackgroundImage ?? undefined;
        message.bannerImg = object.bannerImg ?? undefined;
        message.bannerSize = object.bannerSize?.map((e) => e) || [];
        message.canAssignLinkFlair = object.canAssignLinkFlair ?? undefined;
        message.canAssignUserFlair = object.canAssignUserFlair ?? undefined;
        message.coins = object.coins ?? undefined;
        message.collapseDeletedComments = object.collapseDeletedComments ?? undefined;
        message.commentContributionSettings =
            (object.commentContributionSettings !== undefined && object.commentContributionSettings !== null)
                ? CommentContributionSettings.fromPartial(object.commentContributionSettings)
                : undefined;
        message.commentScoreHideMins = object.commentScoreHideMins ?? undefined;
        message.communityIcon = object.communityIcon ?? undefined;
        message.communityReviewed = object.communityReviewed ?? undefined;
        message.contentCategory = object.contentCategory ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.created = object.created ?? undefined;
        message.defaultSet = object.defaultSet ?? undefined;
        message.description = object.description ?? undefined;
        message.descriptionHtml = object.descriptionHtml ?? undefined;
        message.disableContributorRequests = object.disableContributorRequests ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.displayNamePrefixed = object.displayNamePrefixed ?? undefined;
        message.emojisCustomSize = object.emojisCustomSize?.map((e) => e) || [];
        message.emojisEnabled = object.emojisEnabled ?? undefined;
        message.freeFormReports = object.freeFormReports ?? undefined;
        message.hasMenuWidget = object.hasMenuWidget ?? undefined;
        message.headerImg = object.headerImg ?? undefined;
        message.headerSize = object.headerSize?.map((e) => e) || [];
        message.headerTitle = object.headerTitle ?? undefined;
        message.hideAds = object.hideAds ?? undefined;
        message.iconColor = object.iconColor ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.iconSize = object.iconSize?.map((e) => e) || [];
        message.id = object.id ?? undefined;
        message.isChatPostFeatureEnabled = object.isChatPostFeatureEnabled ?? undefined;
        message.isCrosspostableSubreddit = object.isCrosspostableSubreddit ?? undefined;
        message.isDefaultBanner = object.isDefaultBanner ?? undefined;
        message.isDefaultIcon = object.isDefaultIcon ?? undefined;
        message.isEnrolledInNewModmail = object.isEnrolledInNewModmail ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.lang = object.lang ?? undefined;
        message.linkFlairEnabled = object.linkFlairEnabled ?? undefined;
        message.linkFlairPosition = object.linkFlairPosition ?? undefined;
        message.mobileBannerImage = object.mobileBannerImage ?? undefined;
        message.name = object.name ?? undefined;
        message.notificationLevel = object.notificationLevel ?? undefined;
        message.originalContentTagEnabled = object.originalContentTagEnabled ?? undefined;
        message.over18 = object.over18 ?? undefined;
        message.predictionLeaderboardEntryType = object.predictionLeaderboardEntryType ?? undefined;
        message.previousNames = object.previousNames?.map((e) => e) || [];
        message.primaryColor = object.primaryColor ?? undefined;
        message.publicDescription = object.publicDescription ?? undefined;
        message.publicDescriptionHtml = object.publicDescriptionHtml ?? undefined;
        message.publicTraffic = object.publicTraffic ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.restrictCommenting = object.restrictCommenting ?? undefined;
        message.restrictPosting = object.restrictPosting ?? undefined;
        message.shouldArchivePosts = object.shouldArchivePosts ?? undefined;
        message.shouldShowMediaInCommentsSetting = object.shouldShowMediaInCommentsSetting ?? undefined;
        message.showMedia = object.showMedia ?? undefined;
        message.showMediaPreview = object.showMediaPreview ?? undefined;
        message.spoilersEnabled = object.spoilersEnabled ?? undefined;
        message.submissionType = object.submissionType ?? undefined;
        message.submitLinkLabel = object.submitLinkLabel ?? undefined;
        message.submitText = object.submitText ?? undefined;
        message.submitTextHtml = object.submitTextHtml ?? undefined;
        message.submitTextLabel = object.submitTextLabel ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.subscribers = object.subscribers ?? undefined;
        message.suggestedCommentSort = object.suggestedCommentSort ?? undefined;
        message.title = object.title ?? undefined;
        message.url = object.url ?? undefined;
        message.userCanFlairInSr = object.userCanFlairInSr ?? undefined;
        message.userFlairBackgroundColor = object.userFlairBackgroundColor ?? undefined;
        message.userFlairCssClass = object.userFlairCssClass ?? undefined;
        message.userFlairEnabledInSr = object.userFlairEnabledInSr ?? undefined;
        message.userFlairPosition = object.userFlairPosition ?? undefined;
        message.userFlairRichtext = object.userFlairRichtext?.map((e) => UserFlairRichtext.fromPartial(e)) || [];
        message.userFlairTemplateId = object.userFlairTemplateId ?? undefined;
        message.userFlairText = object.userFlairText ?? undefined;
        message.userFlairTextColor = object.userFlairTextColor ?? undefined;
        message.userFlairType = object.userFlairType ?? undefined;
        message.userHasFavorited = object.userHasFavorited ?? undefined;
        message.userIsBanned = object.userIsBanned ?? undefined;
        message.userIsContributor = object.userIsContributor ?? undefined;
        message.userIsModerator = object.userIsModerator ?? undefined;
        message.userIsSubscriber = object.userIsSubscriber ?? undefined;
        message.userSrFlairEnabled = object.userSrFlairEnabled ?? undefined;
        message.userSrThemeEnabled = object.userSrThemeEnabled ?? undefined;
        message.videostreamLinksCount = object.videostreamLinksCount ?? undefined;
        message.whitelistStatus = object.whitelistStatus ?? undefined;
        message.wikiEnabled = object.wikiEnabled ?? undefined;
        message.wls = object.wls ?? undefined;
        message.markedSpam = object.markedSpam ?? undefined;
        message.postRequirements = (object.postRequirements !== undefined && object.postRequirements !== null)
            ? Subreddit_PostRequirements.fromPartial(object.postRequirements)
            : undefined;
        message.userIsMuted = object.userIsMuted ?? false;
        return message;
    },
};
messageTypeRegistry.set(Subreddit.$type, Subreddit);
function createBaseSubreddit_PostRequirements() {
    return { bodyRestrictionPolicy: undefined };
}
export const Subreddit_PostRequirements = {
    $type: "devvit.reddit.Subreddit.PostRequirements",
    encode(message, writer = _m0.Writer.create()) {
        if (message.bodyRestrictionPolicy !== undefined) {
            StringValue.encode({ value: message.bodyRestrictionPolicy }, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubreddit_PostRequirements();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.bodyRestrictionPolicy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            bodyRestrictionPolicy: isSet(object.bodyRestrictionPolicy) ? String(object.bodyRestrictionPolicy) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.bodyRestrictionPolicy !== undefined) {
            obj.bodyRestrictionPolicy = message.bodyRestrictionPolicy;
        }
        return obj;
    },
    create(base) {
        return Subreddit_PostRequirements.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubreddit_PostRequirements();
        message.bodyRestrictionPolicy = object.bodyRestrictionPolicy ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(Subreddit_PostRequirements.$type, Subreddit_PostRequirements);
function isSet(value) {
    return value !== null && value !== undefined;
}
